import COMPANY_OBJECT from './COMPANY_OBJECT'
import DEVICE from './DEVICE'
import CENTRAL_HEATING_DEVICE from './CENTRAL_HEATING_DEVICE'
import COLD_WATER_DEVICE from './COLD_WATER_DEVICE'

export default {
  COMPANY_OBJECT,
  DEVICE,
  CENTRAL_HEATING_DEVICE,
  COLD_WATER_DEVICE
}
